<template>
    <div>
        <q-card
            class="bg-primary"
            style="cursor: pointer"
            clickable
            v-ripple
            v-if="!props.row.id && $auth.can('transfer-limits.set')"
            @click="make_mode = true"
            v-show="!make_mode"
        >
            <q-card-section class="flex flex-center">
                <q-icon name="fa fa-plus" color="white" size="40px"/>
            </q-card-section>
            <q-card-section class="text-white text-center text-h6">
                New Transfer Limit
            </q-card-section>
        </q-card>

        <q-card flat bordered class="card-shadow bg-grey-1" v-else>
            <q-list bordered class="rounded-borders">
                <q-item>
                    <q-item-section avatar class="flex-center">
                        <q-icon :name="props.row.ramp.from.country" size="md" />
                    </q-item-section>

                    <q-item-section  class="flex-center">
                        <q-icon name="fa fa-arrow-right" size="md"/>
                    </q-item-section>

                    <q-item-section side>
                        <q-icon :name="props.row.ramp.to.country" size="md" />
                    </q-item-section>
                </q-item>
                <q-item>
                    <q-item-section avatar class="flex-center">
                        {{ props.row.ramp.from.currency}}
                    </q-item-section>
                    <q-item-section  class="text-center">
                        <q-item-label>
                            <currency-format
                                :value="props.row.max_monthly_transfer"
                                :unit="props.row.ramp.from.currency"
                                hide-white-spaces
                                hide-zero-decimal
                                style="font-size: 20px"
                                class="text-body2"
                            />
                        </q-item-label>
                    </q-item-section>
                    <q-item-section side class="text-body2 text-black q-mr-xs">
                        {{ props.row.ramp.to.currency}}
                    </q-item-section>
                </q-item>
            </q-list>

            <q-card-actions class="flex justify-end q-py-sm" v-if="$auth.can('transfer-limits.set')">
                <q-btn dense outline color="red" class="q-px-xs" @click="unsetConfirmation" v-if="! showUnsetConfirmation">{{$t('ramps.remove')}}</q-btn>
                <q-btn dense color="red" class="q-px-xs" @click="unsetLimit" :loading="loading" v-else>{{$t('ramps.confirm')}}</q-btn>
            </q-card-actions>
        </q-card>

        <q-card v-show="make_mode" class="shadow-9">
            <q-card-section>
                <div class="col-12">
                    <q-select
                        v-model="selectedRamp"
                        :options="active_ramps"
                        :error="transferLimit.errors.has('ramp_id')"
                        :error-message="transferLimit.errors.get('ramp_id')"
                        label="Ramp"
                        color="primary"
                        @input="grabRamp"
                    >
                        <template v-slot:option="scope">
                            <q-item v-bind="scope.itemProps"
                                    v-on="scope.itemEvents"
                                    style="border-bottom:1px solid #999"
                            >
                                <q-item-section class="col-2 flex-center">
                                    <q-icon :name="scope.opt.from_country.acronym" size="md" /> {{scope.opt.from_currency.symbol}}
                                </q-item-section>

                                <q-item-section  class="col-8 flex-center">
                                    <currency-format
                                        :value="scope.opt.max_monthly_transfer"
                                        :unit="scope.opt.from_currency.acronym"
                                        hide-white-spaces
                                        hide-zero-decimal
                                        style="font-size: 16px"
                                        class="text-body2 text-grey"
                                    />
                                </q-item-section>

                                <q-item-section class="col-2 flex-center">
                                    <q-icon :name="scope.opt.to_country.acronym" size="md" /> {{scope.opt.to_currency.symbol}}
                                </q-item-section>
                            </q-item>
                        </template>

                        <template v-slot:selected>
                            <q-item class="full-width" v-if="selectedRamp">
                                <q-item-section class="col-2 flex-center">
                                    <q-icon :name="selectedRamp.from_country.acronym" size="md" /> {{selectedRamp.from_currency.symbol}}
                                </q-item-section>

                                <q-item-section  class="col-8 flex-center">
                                    <q-icon name="fa fa-arrow-right" size="md"/>
                                </q-item-section>

                                <q-item-section class="col-2 flex-center">
                                    <q-icon :name="selectedRamp.to_country.acronym" size="md" /> {{selectedRamp.to_currency.symbol}}
                                </q-item-section>
                            </q-item>
                        </template>
                    </q-select>
                </div>
                <div class="col-12">
                    <q-input
                        v-model="transferLimit.max_monthly_transfer"
                        :error="transferLimit.errors.has('max_monthly_transfer')"
                        :error-message="transferLimit.errors.get('max_monthly_transfer')"
                        label="New limit amount"
                        input-class="text-center"
                        color="primary"
                    >
                        <template v-slot:append>
                            <small>{{selectedRamp ? selectedRamp.from_currency.symbol : '?'}}</small>
                        </template>
                    </q-input>
                </div>
            </q-card-section>

            <q-separator/>

            <q-card-actions align="between">
                <q-btn flat @click="make_mode = false" label="cancel" />
                <q-btn color="primary" icon="fa fa-plus" @click="setLimit" label="Set"/>
            </q-card-actions>

            <q-inner-loading
                :showing="loading"
                label="Loading..."
                label-class="text-primary"
                label-style="font-size: 1.1em"
            />
        </q-card>
    </div>
</template>
<script>

import TransferLimit from "../models/TransferLimit"
import {mapGetters} from 'vuex'
export default {
    name: "TransferLimitCard",
    model: {
        prop: 'props'
    },
    props: {
        props: {
            type: Object,
            required: true
        },
        userId: {
            type: Number,
            required: true
        }
    },
    computed: {
        ...mapGetters(['ramps']),
        active_ramps() {
            return this.ramps.filter(ramp => ramp.is_active)
        }
    },
    data() {
        return {
            term: '',
            limits: [],
            make_mode: false,
            loading: false,
            showUnsetConfirmation: false,
            selectedRamp: null,
            max_monthly_transfer: 0,
            transferLimit: this.initTransferLimit()
        }
    },
    methods: {
        initTransferLimit() {
            return new TransferLimit({
                user_id: this.userId,
                ramp_id: undefined,
                max_monthly_transfer: 0
            })
        },
        setLimit() {
            this.loading = true
            this.transferLimit.create((data) => {
                this.$emit('attach', data)
                this.selectedRamp = null
                this.make_mode = false
                this.loading = false
            }).catch(({data}) => {
                this.loading = false
            })
        },
        unsetConfirmation() {
            this.showUnsetConfirmation = true
            setTimeout(() => {
                this.showUnsetConfirmation = false
            }, 2000)
        },
        unsetLimit() {
            this.loading = true
            new TransferLimit({id: this.props.row.id}).destroy( () => {
                this.transferLimit = this.initTransferLimit()
                this.$emit('detach', this.props.row.id)
                this.loading = false
            }).catch((error) => {
                this.loading = false
            })
        },
        grabRamp(ramp) {
            this.selectedRamp = ramp
            this.transferLimit.ramp_id = ramp.id
        },
    },
    created() {},
    mounted() {},
    watch: {},
    components: {},
}
</script>
<style>

</style>
